<ng-container *ngIf="isDialogMode; else routeEditor">
  <app-modal-shell [config]="modalConfig">
    <form modal-content id="assignment-editor-form" [formGroup]="form" (ngSubmit)="saveAssignment()" class="assignment-dialog-content">
      <mat-form-field class="full-width">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="name" maxlength="100">
        <mat-error *ngIf="form.get('name')?.hasError('required')">El nombre es requerido</mat-error>
        <mat-error *ngIf="form.get('name')?.hasError('minlength')">El nombre debe tener al menos 3 caracteres</mat-error>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Área</mat-label>
        <mat-select formControlName="areaId">
          <mat-option *ngFor="let area of areaOptions" [value]="area.id">{{ area.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('areaId')?.hasError('required')">El área es requerida</mat-error>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Niveles permitidos</mat-label>
        <mat-select formControlName="allowedOrganizationLevelIds" multiple>
          <mat-option *ngFor="let level of organizationLevelOptions" [value]="level.id">
            {{ level.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('allowedOrganizationLevelIds')?.hasError('required')">
          Selecciona al menos un nivel
        </mat-error>
      </mat-form-field>

      <mat-checkbox formControlName="requiresActiveMinistry">
        Requiere ministerio activo
      </mat-checkbox>
    </form>
    <ng-container modal-actions>
      <button mat-button type="button" (click)="cancel()">Cancelar</button>
      <button mat-flat-button color="primary" type="submit" form="assignment-editor-form" [disabled]="isSaving">
        <mat-icon *ngIf="!isSaving">save</mat-icon>
        <mat-progress-spinner *ngIf="isSaving" diameter="20"></mat-progress-spinner>
        {{ isSaving ? 'Guardando...' : 'Guardar' }}
      </button>
    </ng-container>
  </app-modal-shell>
</ng-container>

<ng-template #routeEditor>
  <div class="editor-container">
    <section class="feature-page">
      <app-page-header
        [title]="isEditMode ? 'Editar nombramiento' : 'Nuevo nombramiento'"
        [subtitle]="isEditMode ? 'Modifica los datos del nombramiento' : 'Crea un nuevo nombramiento'">
      </app-page-header>

      <div class="feature-page__content form-wrapper">
        <form [formGroup]="form" (ngSubmit)="saveAssignment()" class="assignment-form">
          <mat-form-field class="full-width">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="name" maxlength="100">
            <mat-error *ngIf="form.get('name')?.hasError('required')">El nombre es requerido</mat-error>
            <mat-error *ngIf="form.get('name')?.hasError('minlength')">El nombre debe tener al menos 3 caracteres</mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Área</mat-label>
            <mat-select formControlName="areaId">
              <mat-option *ngFor="let area of areaOptions" [value]="area.id">{{ area.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('areaId')?.hasError('required')">El área es requerida</mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Niveles permitidos</mat-label>
            <mat-select formControlName="allowedOrganizationLevelIds" multiple>
              <mat-option *ngFor="let level of organizationLevelOptions" [value]="level.id">
                {{ level.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('allowedOrganizationLevelIds')?.hasError('required')">
              Selecciona al menos un nivel
            </mat-error>
          </mat-form-field>

          <mat-checkbox formControlName="requiresActiveMinistry">
            Requiere ministerio activo
          </mat-checkbox>

          <div class="actions">
            <button mat-button type="button" (click)="cancel()">Cancelar</button>
            <button mat-flat-button color="primary" type="submit" [disabled]="isSaving">
              <mat-icon *ngIf="!isSaving">save</mat-icon>
              <mat-progress-spinner *ngIf="isSaving" diameter="20"></mat-progress-spinner>
              {{ isSaving ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</ng-template>
